/* eslint-disable */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'utils/axios';

const name = 'Terms&Condition';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
    name,
    initialState,
    extraReducers
});

export const TermsActions = { ...slice.actions, ...extraActions };

export default slice.reducer;

function createInitialState() {
    return {
        terms: ''
    };
}

function createExtraActions() {
    return {
        fetchAllTerms: fetchAllTerms(),
        createTerms: createTerms()
    };
}

function fetchAllTerms() {
    return createAsyncThunk(`${name}/fetchAllTerms`, async () => {
        try {
            const response = await axios.get(`/tos`);
            // // console.log(response, 'res-thunk');
            return response.data;
        } catch (err) {
            throw new Error(err?.errors?.message);
        }
    });
}

function createTerms() {
    return createAsyncThunk(`${name}/createTerms`, async (data) => {
        try {
            const response = await axios.post(`/tos`, {
                userAgreement: true,
                variablesValues: data
            });
            return response;
        } catch (err) {
            throw err;
        }
    });
}

function createExtraReducers() {
    return {
        ...fetchAllTerms()
    };

    function fetchAllTerms() {
        const { pending, fulfilled, rejected } = extraActions.fetchAllTerms;
        return {
            [pending]: (state) => {
                // state.loading = true;
                // state.listings = [];
            },
            [fulfilled]: (state, action) => {
                // state.loading = false;
                // state.listings = action.payload?.properties;
                state.terms = action?.payload;
            },
            [rejected]: (state, action) => {
                // state.listings = [];
                // state.loading = false;
                // state.error = action.error.message;
            }
        };
    }
}
